import { Licensing } from '@adaptiva/core/licensing';
import { ILazyLoadedRegistration } from '@adaptiva/core/loaders';
import { LicenseManagerService } from '@adaptiva/data-service';
import { inject } from '@angular/core';

export const LAZY_LOADED_REGISTRATIONS: ILazyLoadedRegistration[] = [
	{
		trigger: () => {
			const _licensing: LicenseManagerService = inject(LicenseManagerService);

			return _licensing.isThirdPartyProductIntegrated(Licensing.ThirdParty.CONFIGMGR);
		},
		product: Licensing.ThirdParty.CONFIGMGR,
		load: () => import('@adaptiva/onesite/lazy').then(m => m.OneSiteConfigManagerClassLoaderModule)
	},
];
